module.exports = __webpack_public_path__ + "img/twitter.7b7539ef.svg";